'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _take2 = require('lodash/take');

var _take3 = _interopRequireDefault(_take2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _utils = require('helpers/utils');

var _reactAttrsFilter = require('react-attrs-filter');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var suggestionTheme = require('theme/components/autosuggest.scss');

var AutosuggestField = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AutosuggestField, _Component);

  function AutosuggestField() {
    var _ref;

    (0, _classCallCheck3.default)(this, AutosuggestField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutosuggestField.__proto__ || (0, _getPrototypeOf2.default)(AutosuggestField)).call.apply(_ref, [this].concat(args)));

    _this.state = { value: '', suggestions: [] };
    return _this;
  }

  (0, _createClass3.default)(AutosuggestField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.changeWidth();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: 'onSuggestionKwChange',
    value: function onSuggestionKwChange(event, _ref2) {
      var newValue = _ref2.newValue;

      if (typeof newValue !== 'undefined' && !this.unmounted) {
        this.setState({ value: newValue });
      }
    }
  }, {
    key: 'onSuggestionsFetchRequested',
    value: function onSuggestionsFetchRequested(_ref3) {
      var value = _ref3.value;

      if (!this.unmounted) {
        this.setState({ suggestions: this.getSuggestions(value) });
      }
    }
  }, {
    key: 'onSuggestionsClearRequested',
    value: function onSuggestionsClearRequested() {
      if (!this.unmounted) {
        this.setState({ suggestions: [] });
      }
    }
  }, {
    key: 'onSuggestionSelected',
    value: function onSuggestionSelected(e, val) {
      var _this2 = this;

      this.props.onSuggestionSelected(e, val).then(function () {
        if (!_this2.unmounted) {
          _this2.setState({ value: '' });
        }
        _this2.changeWidth();
      });
    }
  }, {
    key: 'getSuggestionValue',
    value: function getSuggestionValue(suggestion) {
      return (0, _get3.default)(suggestion, this.props.field);
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions(value) {
      var _props = this.props,
          onGetSuggestions = _props.onGetSuggestions,
          items = _props.items,
          field = _props.field,
          maxSuggestions = _props.maxSuggestions;

      var suggestions = onGetSuggestions ? onGetSuggestions(value) : (0, _utils.filterObjectsByKw)(items, [field], value);
      return maxSuggestions ? (0, _take3.default)(suggestions, maxSuggestions) : suggestions;
    }
  }, {
    key: 'changeWidth',
    value: function changeWidth() {
      if (!this.props.autoWidth || typeof document === 'undefined' || typeof window === 'undefined') {
        return false;
      }
      var inputEl = this.fieldEl.input;
      var tmp = document.createElement('span');
      var inputStyle = window.getComputedStyle(inputEl);
      tmp.innerHTML = inputEl.value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      tmp.style.padding = inputStyle.padding;
      tmp.style.paddingLeft = inputStyle['padding-left'];
      tmp.style.paddingRight = inputStyle['padding-right'];
      tmp.style.fontSize = inputStyle.fontSize;
      tmp.style.border = inputStyle.border;
      tmp.style.visibility = 'hidden';
      inputEl.parentNode.appendChild(tmp);
      var theWidth = Math.ceil(tmp.getBoundingClientRect().width);
      inputEl.parentNode.removeChild(tmp);
      inputEl.style.width = theWidth + 5 + 'px';

      return theWidth;
    }
  }, {
    key: 'renderSuggestion',
    value: function renderSuggestion(suggestion) {
      return _react2.default.createElement(
        'span',
        null,
        (0, _get3.default)(suggestion, this.props.field)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          readOnly = _props2.readOnly,
          placeholder = _props2.placeholder,
          onSuggestionSelected = _props2.onSuggestionSelected,
          items = _props2.items,
          field = _props2.field,
          autoWidth = _props2.autoWidth,
          withZIndex = _props2.withZIndex,
          otherProps = (0, _objectWithoutProperties3.default)(_props2, ['readOnly', 'placeholder', 'onSuggestionSelected', 'items', 'field', 'autoWidth', 'withZIndex']); // eslint-disable-line no-unused-vars

      var _state = this.state,
          suggestions = _state.suggestions,
          value = _state.value;

      var inputProps = (0, _extends3.default)({
        placeholder: placeholder,
        value: value,
        readOnly: readOnly
      }, otherProps.inputProps);

      var onChange = inputProps.onChange;
      inputProps.onChange = function (e) {
        if (onChange) {
          onChange(e);
        }
        _this3.onSuggestionKwChange(e, { newValue: e.target.value });
        _this3.changeWidth();
      };

      var filteredInputProps = (0, _reactAttrsFilter.filterPropsFor)(inputProps, 'input');
      if (inputProps.onKeyPress) {
        filteredInputProps.onKeyPress = inputProps.onKeyPress;
      }

      var theme = (0, _extends3.default)({}, suggestionTheme);
      if (withZIndex) {
        theme.container = theme.containerWithZIndex;
      }

      return _react2.default.createElement(_reactAutosuggest2.default, (0, _extends3.default)({
        ref: function ref(el) {
          return _this3.fieldEl = el;
        }
      }, otherProps, {
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        getSuggestionValue: this.getSuggestionValue,
        renderSuggestion: this.renderSuggestion,
        onSuggestionSelected: this.onSuggestionSelected,
        theme: suggestionTheme,
        focusFirstSuggestion: true,
        inputProps: filteredInputProps,
        highlightFirstSuggestion: true
      }));
    }
  }]);
  return AutosuggestField;
}(_react.Component), _class2.propTypes = {
  autoWidth: _propTypes2.default.bool,
  field: _propTypes2.default.string.isRequired,
  items: _propTypes2.default.array.isRequired,
  maxSuggestions: _propTypes2.default.number,
  onGetSuggestions: _propTypes2.default.func,
  onSuggestionSelected: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  withZIndex: _propTypes2.default.bool
}, _class2.defaultProps = {
  maxSuggestions: 30,
  withZIndex: true
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSuggestionsFetchRequested', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSuggestionsFetchRequested'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSuggestionsClearRequested', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSuggestionsClearRequested'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onSuggestionSelected', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSuggestionSelected'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getSuggestionValue', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getSuggestionValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getSuggestions', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getSuggestions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'renderSuggestion', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'renderSuggestion'), _class.prototype)), _class);
exports.default = AutosuggestField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestField/AutosuggestField.js
// module id = 1958
// module chunks = 1